import {XauditModel} from '../../../models/xaudit.model';

export class ReportsLetterSubstituteModel extends XauditModel {
    LetterSubstitueID: string;
    ReportID: string;
    LOCID: string;
    LetterTemplateID: string;
    LetterName: string;
}

export class ReportLetterSubstituteParameterModel {
    ID: string;
    WebID: string;
    sqlStatement: string;
    LetterSubstituteID: string;
    Order: number;
    isParent: boolean;
    ParentID: string;
}
